export default {
  name: 'ThemeForest',
  abbreviation: 'TF',
  domain: 'themeforest.net',
  google_analytics_id: 'UA-11834194-7',
  google_remarketing_label: 'u-J6CI3SqQMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. responsive wordpress',
  features: {
    /**
     * @description Shows key features on the TF narrow item card.
     * Needed to reuse `narrowItemCard` component on across different sites and configure the item card parts which vary on different sites
     * @author Tanya Fonina
     * @expires When all item cards have been migrated to updated narrow item cards and we'll decide how to refactor it to re-use as many components/styles as possible
     */
    'metaInfo:showKeyFeatures': true,
    /**
     * @description
     * @author Luke Jones
     * @expires
     */
    'item-preview-with-carousel': true
  },
  assets_domains: {
    item_thumbnail: 'thumb-tf.s3.envato.com',
    item_image: 'image-tf.s3.envato.com'
  },
  show_category_in_selected_filters: true
}
